import script from "./ChartPool.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartPool.vue?vue&type=script&lang=ts&setup=true"

import "./ChartPool.vue?vue&type=style&index=0&id=3870b42e&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3870b42e"]])

export default __exports__